/*
 * Copyright (c) 2021. World Wide Generation Ltd
 */

import React from 'react';
import ToolbarButton, { ToolbarButtonProps } from './ToolbarButton';
import ToolbarIcon, { ToolbarIconProps } from './ToolbarIcon';

interface ToolbarColumnProps {
  buttons?: ToolbarButtonProps[];
  icons?: ToolbarIconProps[];
  children?: JSX.Element | JSX.Element[];
  title: string;
  className?: string;
}

const ToolbarColumn = (props: ToolbarColumnProps) => {
  const { buttons, icons, children, title, className } = props;

  const isEmpty = !children && (!icons || icons.length === 0) && (!buttons || buttons.length === 0);

  return <div className={`${className} d-flex flex-column`}>
    <div className='header'>{isEmpty ? '' : title}</div>
    <div className='d-flex justify-content-start'>
      {buttons && buttons.map((button, i) => (
        <ToolbarButton
          key={`${title}-${i}`}
          {...button}
        />
      ))}
      {icons && icons.map((icon, i) => (
        <ToolbarIcon
          key={`${title}-${i}`}
          {...icon}
        />
      ))}
      {children}
    </div>
  </div>
}

export default ToolbarColumn;
